import React from 'react';
import Color from 'components/color';
import _ from 'lodash';

import createReactClass from 'create-react-class';
export default createReactClass({
  componentDidMount() {
    let initialized = false;
    this.$input = $(this.refs.input);
    this.$input.minicolors({
      theme: 'bootstrap',
      position: this.props.position || 'left',
      opacity: this.props.opacity ? this.props.opacity : false,
      letterCase: 'uppercase',
      change: function() {
        if (!initialized) return;
        let color = new Color(this.$input.minicolors('rgbObject'));
        if (color) {
          this.props.onChange({
            target: { value: color.toRgba() },
            preventDefault() {},
          });
        }
      }.bind(this),
    });
    let defaultValue = new Color(this.props.defaultValue);
    this.$input.minicolors('opacity', defaultValue.a);
    this.$input.minicolors('value', defaultValue.toHex());
    initialized = true;
  },

  componentWillUnmount() {
    this.$input.minicolors('destroy');
  },

  manualEntry(event) {
    this.lazyUpdate(event.target.value);
    event.preventDefault();
  },

  lazyUpdate: _.debounce(function(value) {
    const color = new Color(value);
    if (color) {
      this.$input.minicolors('opacity', color.a);
      this.$input.minicolors('value', color.toHex());
    }
  }, 600),

  render() {
    let classes = ['control-group color-control'];
    if (this.props.className) {
      classes.push(this.props.className);
    }
    return (
      <div className={classes.join(' ')} style={this.props.style}>
        <label>{this.props.label}</label>
        <div className="controls">
          <input
            ref="input"
            type="text"
            name={this.props.name}
            onChange={this.manualEntry}
            defaultValue={this.props.defaultValue}
          />
        </div>
      </div>
    );
  },
});
